import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ChannelEvents } from '../../../../shared/models/common/channels/channelEvents';
import { ChannelService } from '../../../../shared/services/channel/channel.service';
import { EventService } from '../../../../shared/services/event/event.service';
import { AuthService } from '../../../../shared/services/security/auth.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-channel-selection-dropdown',
  templateUrl: '../template-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChannelSelectionDropdownComponent extends DropdownBaseComponent implements OnInit, AfterViewInit {

  constructor(
    private readonly dropdownService: DropDownService,
    private readonly channelService: ChannelService,
    protected readonly translatorService: TranslatorService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly eventService: EventService,
    private readonly authService: AuthService,
  ) {
    super(translatorService);
  }

  ngAfterViewInit(): void {
    if (this.authService.hasDropdownRulesTheUserRole()) {
      this.itemsData.shift();
      this.itemsData.push({ id: 'no-id', name: this.translator.trans('dropdown.unknown') });
    }
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.channelService.channelQuery$(null, null, this.dropdownWithRules).subscribe(res => {
      this.itemsData = this.itemsData.concat(res.channelList);
      this.leadComuService.channels = res.channelList;
    });
  }

  selectItem($event: any) {
    const item = this.itemsData.find(data => data.id === $event.id);
    this.itemSelectedFunction(item);
    this.eventService.broadcast(ChannelEvents.NEW_CHANNEL_SELECTED, item);
  }

}
